/* @generated */

// src/assets/ui-icon/line/legal.tsx
import * as React from "react";
var LegalLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M20.483 12.5a3.22 3.22 0 0 0-.186-.93L17.864 5H5.636l-2.432 6.57A3.231 3.231 0 0 0 3 12.7v.3h.005c.022 1.961 1.141 3 3.245 3s3.223-1.039 3.245-3H9.5v-.5h-.018a3.22 3.22 0 0 0-.184-.93L7.42 6.5H11v11H9V19h5.5v-1.5h-2v-11h3.58l-1.877 5.07A3.231 3.231 0 0 0 14 12.7v.3h.005c.022 1.961 1.141 3 3.245 3s3.223-1.039 3.245-3h.005v-.5h-.017Zm-14.233 2c-1.441 0-1.736-.528-1.75-1.5H8c-.014.972-.309 1.5-1.75 1.5Zm1.423-3H4.827L6.25 7.66l1.423 3.84Zm9.577-3.84 1.422 3.84h-2.845l1.423-3.84Zm0 6.84c-1.441 0-1.736-.528-1.75-1.5H19c-.014.972-.308 1.5-1.75 1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  LegalLine
};
